import React from "react";
import { useTranslation } from "react-i18next";
import * as psdaAssets from "@tvet-mis/psda-assets";
import { OptimizedSvg } from "@components/common/OptimizedSvg";

const assetsRecord = psdaAssets as unknown as Record<string, string>;
const sidebarLogo = assetsRecord.authCommonLogo || assetsRecord.applicationLogoV2;

interface SidebarBrandingProps {
	isExpanded: boolean;
}

/** Logo in the dark sidebar header band. */
export const SidebarBranding: React.FC<SidebarBrandingProps> = React.memo(({ isExpanded }) => {
	const { t } = useTranslation();

	return (
		<div className="sidebar-branding flex w-full shrink-0 flex-col items-center text-center">
			<OptimizedSvg
				src={sidebarLogo}
				alt={t("layout.sidebar.brand.logoAlt")}
				className={`sidebar-branding__logo ${
					isExpanded ? "sidebar-branding__logo--expanded" : "sidebar-branding__logo--collapsed"
				} [&>svg]:h-full [&>svg]:w-auto [&>svg]:max-w-full`}
				cacheKey="sidebar-brand-logo"
			/>
		</div>
	);
});

SidebarBranding.displayName = "SidebarBranding";
